const smartId = require('../../tools/smart-id')

const generateUnknownBatchForProduct = require('./virtual-batch').getUnknownBatchID

/**
 * Extracts the generic product ID from a batch ID.
 * @param {string} batchId - Batch ID in format "product:CODE:manufacturer:MANUFACTURER:batchNo:BATCH"
 * @returns {string} Product ID in format "product:CODE"
 * @example
 * batchIdToProductId('product:fds-aid0002:manufacturer:ghsc-aid0742a:batchNo:E252050')
 * // returns 'product:fds-aid0002'
 */
const batchIdToProductId = batchId => batchId.split(':').slice(0, 2).join(':')

const isBatchId = id => id.indexOf(':manufacturer:') !== -1 && id.indexOf(':batchNo:') !== -1

const isSnapshotId = id => id.indexOf(':agent:') > id.indexOf(':status:')

/**
 * Parses a batch ID into its product/manufacturer/batchNo parts. The batchNo is
 * extracted colon-safely (via `:batchNo:(.+)$`), so batchNos that themselves
 * contain a colon (e.g. '50766P1D1/SUB:1') are preserved rather than truncated
 * at the first colon by smart-id parse().
 * @param {string} batchId - Batch ID in format "product:CODE:manufacturer:MANUFACTURER:batchNo:BATCH"
 * @returns {{manufacturer: string, productId: string, batchNo: string}}
 * @example
 * parseBatchId('product:ghsc-mal0009:manufacturer:chemonics:batchNo:50766P1D1/SUB:1')
 * // returns { manufacturer: 'chemonics', productId: 'product:ghsc-mal0009', batchNo: '50766P1D1/SUB:1' }
 */
const parseBatchId = (batchId = '') => {
  const {product, manufacturer, batchNo: parsedBatchNo} = smartId.parse(batchId)
  const batchNoMatch = batchId.match(/:batchNo:(.+)$/)
  const batchNo = batchNoMatch ? batchNoMatch[1] : parsedBatchNo
  return {
    manufacturer,
    productId: `product:${product}`,
    batchNo
  }
}

module.exports = {
  generateUnknownBatchForProduct,
  batchIdToProductId,
  parseBatchId,
  isBatchId,
  isSnapshotId
}
